import type { SchemaData, SchemaStation } from '../../schema/types'

/**
 * Resolves a station-page URL reference to its schema record. The URL
 * accepts any public identifier — NAPTAN id (stable TfL key), SEO slug,
 * or internal schema id — so links from the map, prerendered pages and
 * TfL-derived data all land without a translation table.
 *
 * `preferredLineId` (the page's `?line-id=`) picks that line's record
 * out of a multi-line cluster; unknown/absent falls back to the default
 * pick (first match, mirroring `buildSlugIndex` — the cluster shares
 * page-level facts either way).
 */
export function resolveStationRef(
  schema: SchemaData,
  ref: string,
  preferredLineId?: string,
): SchemaStation | null {
  let base: SchemaStation | null = null
  for (const station of schema.stations) {
    if (station.naptanId === ref || station.id === ref) {
      base = station
      break
    }
  }
  if (base === null) {
    for (const station of schema.stations) {
      if (station.slug === ref) {
        base = station
        break
      }
    }
  }
  if (base === null || preferredLineId === undefined || base.naptanId === undefined) return base
  return (
    schema.stations.find((s) => s.naptanId === base.naptanId && s.line?.id === preferredLineId) ??
    base
  )
}
